'use strict';

import { isNeObject, isNumberGreaterThanOrEqual, isObject } from '@aretheyhappy/utils';

const ScrollOverlayDir = {
    bind: function (el, binding) {
        const opts = Object.freeze(Object.assign({
            uid         : false,
            end         : false,
            at          : false,
            at_cname    : 'scrolltrigger',
            mode        : 'scroll',     //  Set to 'auto'/'scroll'/...
            pad         : {l: 1, r: 0},
        }, isObject(binding.value) ? binding.value : {}));

        //  Variables
        const meta = {
            end_reached         : false,
            end_reached_channel : `${opts.uid}:scroll_end`,
            at_reached          : false,
        };

        //  Function: End Evaluation
        const fnEnd = ratio => {
            //  Check if scrollbar hasn't reached bottom yet
            if (ratio.y < 0.95) return meta.end_reached = false;

            //  We fire flash based on whether or not bottom was already reached or not
            if (!meta.end_reached) {
                meta.end_reached = true;
                MeadCommon.Flash.publish(meta.end_reached_channel);
            }
        };

        //  Function : At Evaluation
        const fnAt = pos => {
            if (pos.y >= opts.at && meta.at_reached) return;
            if (pos.y < opts.at && !meta.at_reached) return;

            meta.at_reached = !!(pos.y >= opts.at);
            el.classList[meta.at_reached ? 'add' : 'remove'](opts.at_cname);
        };

        //  Set styling
        el.style.overflowY = opts.mode;
        el.style.scrollbarColor = 'var(--c-scrollbar-bg) transparent';

        //  Apply padding behavior
        if (isNeObject(opts.pad)) {
            if (isNumberGreaterThanOrEqual(opts.pad.l, 0)) el.style.paddingLeft = `${opts.pad.l}rem`;
            if (isNumberGreaterThanOrEqual(opts.pad.r, 0)) el.style.paddingRight = `${opts.pad.r}rem`;
        }

        //  If scroll needs to be listened to
        if (opts.end || opts.at) {
            el.addEventListener('scroll', () => {
                if (opts.end) fnEnd({y: (el.scrollTop + el.offsetHeight)/el.scrollHeight});
                if (opts.at) fnAt({y: el.scrollTop});
            });
        }

        el.$scrollOverlay = {
            scrollYPct: (pct = 0) => {
                el.scroll(0, (el.scrollHeight * (pct/100)) - (el.getBoundingClientRect().height * 0.5));
            },
            scrollToElem: id => {
                const to_el = document.getElementById(id);
                if (to_el) to_el.scrollIntoView({behavior: MeadCommon.DomUtils.prefersReducedMotion() ? 'auto' : 'smooth'});
            },
            reset: () => {
                meta.end_reached = false;
            },
        };
    },
};

/**
 * Adds scroll overlay directive to vue. Use with `v-ath-scroll-overlay` or `v-mead-scroll-overlay`.
 * The `v-ath-scroll-overlay` version is deprecated; use `v-mead-scroll-overlay` instead.
 */
const ScrollOverlayDirective = {
    bind: function (vue) {
        vue.directive('athScrollOverlay', ScrollOverlayDir);
        vue.directive('meadScrollOverlay', ScrollOverlayDir);
    }
}

export default ScrollOverlayDirective;
